import LayoutAssets from './LayoutAssets.vue'
export default LayoutAssets



// WEBPACK FOOTER //
// ./src/layouts/layoutAssets/index.js